import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { OrderFieldMapService } from 'core/http/project/rule-set/order-field-map.service';
import { ownedError } from 'core/utils/owned-error';
import { projectScopedRequest } from 'core/utils/rx-common';
import { defer, of } from 'rxjs';
import { catchError, finalize, map, switchMap, throwIfEmpty } from 'rxjs/operators';
import * as FieldMapActions from './field-map.actions';

@Injectable()
export class FieldMapEffects {
  private _requestVersion = 0;

  getOrderFieldMap$ = createEffect(() => this.actions$.pipe(
    ofType(FieldMapActions.getOrderFieldMap),
    map(() => {
      this._requestVersion += 1;
      return this._requestVersion;
    }),
    switchMap(version => defer(() => {
      this.store$.dispatch(FieldMapActions.setLoading({ value: true }));
      return projectScopedRequest(this.store$, () => defer(() => this.fieldMapService.getOrderFieldMap()).pipe(
        throwIfEmpty(() => ownedError(new Error('ERROR.order_fields_load_failed'), 'orderFields')),
        switchMap(orderFieldMap => [
          FieldMapActions.saveOrderFieldMap({ orderFieldMap }),
          FieldMapActions.markOrderFieldMapLoaded(),
          FieldMapActions.setLoading({ value: false }),
        ]),
        catchError((error: Error) => of(FieldMapActions.setError({ value: error }))),
      ));
    }).pipe(
      finalize(() => {
        if (version === this._requestVersion) {
          this.store$.dispatch(FieldMapActions.setLoading({ value: false }));
        }
      }),
    )),
  ));

  constructor(
    private actions$: Actions,
    private fieldMapService: OrderFieldMapService,
    private store$: Store,
  ) { }
}
